module.exports = __webpack_public_path__ + "img/gjjh2.930407bd.jpg";